export const GALLERY_MODES = {
  NONE: 'NONE', // null state
  LOADING: 'LOADING', // loading streets from server
  ERROR: 'ERROR', // there is an error loading streets from server
  GALLERY: 'GALLERY' // displaying street gallery
}
